import { render, staticRenderFns } from "./OrderSingleSummary.vue?vue&type=template&id=60237cc9&scoped=true"
import script from "./OrderSingleSummary.vue?vue&type=script&lang=js"
export * from "./OrderSingleSummary.vue?vue&type=script&lang=js"
import style0 from "./OrderSingleSummary.vue?vue&type=style&index=0&id=60237cc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60237cc9",
  null
  
)

export default component.exports